module.exports = __webpack_public_path__ + "static/media/MD_HC_header.8469af6f.png";